import React from 'react'
import useIntl from '@/utils/intl'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/context/AuthContext'

interface Props {
  onClose?: () => void
  instanceId?: string
}

const SuccessZMS: React.FC<Props> = ({ onClose }) => {
  const { translate } = useIntl()
  const router = useRouter()
  const { isWebView } = useAuth()

  const exitWebview = (): void => {
    let webView
    if ((window as any).mobiBridge !== undefined) {
      webView = (window as any).mobiBridge
    }
    if ((window as any).ReactNativeWebview !== undefined) {
      webView = (window as any).ReactNativeWebview
    }
    if (webView !== undefined) {
      const data = { key: 'exit' }
      webView.postMessage(JSON.stringify(data))
    } else {
      console.warn('Webview bridge not found')
      if (onClose != null) onClose()
      router.push('/')
    }
  }

  const handleContinue = (): void => {
    if (isWebView) {
      exitWebview()
    } else {
      if (onClose != null) onClose()
      router.push('/')
    }
  }

  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full md:w-fit min-h-[300px] md:min-h-[400px] flex flex-col justify-between relative mx-auto'>
      <div className='flex-grow px-4 py-4 sm:px-6 sm:py-6 overflow-y-auto flex flex-col gap-4'>
        <div className='flex items-center justify-center relative w-full max-w-[50vw] sm:max-w-[200px] aspect-square mx-auto'>
          <div className='absolute inset-0 flex items-center justify-center'>
            <div className='animate-spin rounded-full h-8 w-8 sm:h-10 sm:w-10 border-4 border-red-500 border-t-transparent' />
          </div>
        </div>

        <div className='px-6 sm:px-12'>
          <span className='text-textHigh font-extrabold text-base sm:text-lg text-center block'>
            {translate('leasing.successzms.title')}
          </span>
          <span className='text-textMid text-xs sm:text-sm text-center whitespace-pre-line block'>
            {translate('leasing.successzms.description')}
          </span>
        </div>
      </div>

      <div className='sticky bottom-0 rounded-b-xl right-0 left-0 z-50 p-4 sm:p-6 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <div className='w-full max-w-[90vw] sm:max-w-md mx-auto flex gap-4'>
          <DarkButton fullwidth size='sm' onClick={handleContinue}>
            {translate('leasing.fail')}
          </DarkButton>
        </div>
      </div>
    </div>
  )
}

export default SuccessZMS
